/**
 * Utility function to create a click handler that navigates to the contact page
 * and focuses the email form field.
 *
 * @param {Function} navigate - The navigate function from useNavigate() hook
 * @returns {Function} Click handler function
 */
export function createContactNavigationHandler(navigate) {
  return event => {
    event.preventDefault();
    navigate('/contact#focus-form');
  };
}
